module.exports = __webpack_public_path__ + "img/any-mask3.63ef73cf.png";